import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'swissCurrency',
  standalone: false
})
export class SwissCurrencyPipe implements PipeTransform {
  transform(val?: number): string {
    if (val !== undefined && val !== null && Number.isFinite(val)) {
      const rounded = Math.round(val + Number.EPSILON);
      return `${rounded.toLocaleString('de-CH')}.-`;
    }
    return '';
  }
}
